import { DashboardTemplate } from '@akin-home/dashboards';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useWindowDimensions } from 'react-native';
import Animated, { FadeInDown } from 'react-native-reanimated';
import styled from 'styled-components/native';

type Props = {
  idx: number;
  template: DashboardTemplate;
  selected?: boolean;
  onPress(id: string): void;
};

export function DashboardSelectionItem(props: Props) {
  const { template } = props;
  const items = template.layout;
  const number_of_items = items?.length || 0;

  function handlePress() {
    props.onPress(template.id);
  }

  const { width } = useWindowDimensions();

  return (
    <Container entering={FadeInDown.duration(700).delay(props.idx * 300)}>
      <Box
        onPress={handlePress}
        selected={props.selected}
        style={{
          width: Math.min(Math.max(width - 40, 300), 375),
        }}
      >
        <PlaceholderBox style={{ backgroundColor: 'rgba(255,123,67,0.15)' }}>
          <Icon icon="calendar" size={40} />
        </PlaceholderBox>

        <RightGrid>
          <GridRow>
            <PlaceholderBox style={{ backgroundColor: '#FFF5DA' }}>
              <Icon icon="user" size={30} />
            </PlaceholderBox>

            {number_of_items > 4 ? (
              <PlaceholderBox style={{ backgroundColor: '#D9E7E3' }}>
                <Icon icon="list-check" size={30} />
              </PlaceholderBox>
            ) : null}
          </GridRow>

          <GridRow>
            <PlaceholderBox style={{ backgroundColor: 'rgba(83,90,241,0.15)' }}>
              <Icon icon="trophy-star" size={30} />
            </PlaceholderBox>

            {number_of_items > 5 ? (
              <PlaceholderBox
                style={{ backgroundColor: 'rgba(20,160,255,0.15)' }}
              >
                <Icon icon="salad" size={30} />
              </PlaceholderBox>
            ) : null}
          </GridRow>
        </RightGrid>

        <CheckContainer>
          {props.selected ? (
            <FilledCheck>
              <FontAwesomeIcon icon="check" color="white" />
            </FilledCheck>
          ) : (
            <EmptyCheck />
          )}
        </CheckContainer>
      </Box>
      <Text>{template.name}</Text>
    </Container>
  );
}

const Container = styled(Animated.View)`
  align-items: center;
  gap: 20px;
`;

const Box = styled.TouchableOpacity<{ selected?: boolean }>`
  position: relative;
  background-color: white;
  aspect-ratio: ${350 / 240};
  border-radius: 17px;

  border-width: 1px;
  border-color: ${({ selected }) => (selected ? colors.primary[70] : 'white')};
  elevation: 2;

  flex-direction: row;
  gap: 8px;
  padding: 8px;
`;

const CheckContainer = styled.View`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const EmptyCheck = styled.View`
  width: 25px;
  height: 25px;
  border-radius: 20px;
  border-width: 2px;
  border-color: ${colors.grey.dim};
`;

const FilledCheck = styled.View`
  width: 27px;
  height: 27px;
  border-radius: 20px;
  background-color: ${colors.primary[70]};

  align-items: center;
  justify-content: center;
`;

const PlaceholderBox = styled.View`
  flex: 1;
  border-radius: 7px;

  align-items: center;
  justify-content: center;
`;

const RightGrid = styled.View`
  gap: 8px;
  flex: 1;
`;

const GridRow = styled.View`
  flex-direction: row;
  gap: 8px;
  flex: 1;
`;

const Icon = styled(FontAwesomeIcon)`
  opacity: 0.5;
`;
